<template>

    <!-- Inactivity Mode -->
    <div id="application-inactivity-mode-overlay" v-if="$store.state.inactivityMode || showInactivityStateWarning">
        <div id="application-inactivity-mode" v-if="$store.state.inactivityMode || showInactivityStateWarning">
            <template v-if="$store.state.inactivityMode">
                <span>Inactivity Mode</span>
            </template>
            <template v-else>
                <span>{{ `Enabling inactivity mode in ` }}</span>
                <span class="timer-text" :class="{warn: appInactivityStateWarningTimerSec <= 600, danger: appInactivityStateWarningTimerSec <= 60}">{{ formatTimeSec(appInactivityStateWarningTimerSec) }}</span>
            </template>
        </div>
    </div>
    
</template>

<script>
export default {
    name: 'InactivityMode',
    props: ['checkIntervalSec'],
    components: {

    },
    data: () => ({
        appInactivityMechanism: 'visibilitychange',  // "visibilitychange" OR "focusblur"

        appInactivityTimestamp: null,
        inactivityDurationSec: 0,

        showInactivityStateWarning: false,
        appInactivityStateWarningTimerSec: null,

        checkForInactivityInterval: null,
        appInactivityStateWarningInterval: null
    }),

    computed: {
        inactivityTimeoutSec() {
            return Math.round(this.$store.state.batchConfig.webapp_settings.preferences.inactivityTimeoutMin * 60);
        },

        inactivityTimeoutWarningSec() {
            // if the configured timeout is more than 30 min then warn at 10 min left. If its less than 30 min then warn at 1 min left.
            if(this.$store.state.batchConfig.webapp_settings.preferences.inactivityTimeoutMin >= 30) {
                return Math.round((this.$store.state.batchConfig.webapp_settings.preferences.inactivityTimeoutMin - 10) * 60); // 10 min left
            }
            else if(this.$store.state.batchConfig.webapp_settings.preferences.inactivityTimeoutMin > 1) {
                return Math.round((this.$store.state.batchConfig.webapp_settings.preferences.inactivityTimeoutMin - 1) * 60);
            }
            else {
                return (this.$store.state.batchConfig.webapp_settings.preferences.inactivityTimeoutMin * 60);
            }
        },
    },

    methods: {
        formatTimeSec: function(time) {
            return TELSA.moment.utc(TELSA.moment.duration(time, "seconds").asMilliseconds()).format("mm:ss");
        },

        appInactivityStateWarningIntervalHandler: function() {
            this.inactivityDurationSec = (this.appInactivityTimestamp ? (TELSA.moment().unix() - this.appInactivityTimestamp) : 0);
            let remainingSec = (this.inactivityTimeoutSec - this.inactivityDurationSec);
            if(remainingSec > 0) {
                this.showInactivityStateWarning = true;
                this.appInactivityStateWarningTimerSec = remainingSec;
            }
            else {
                this.startInactivityMode();
            }
        },

        checkForInactivity: function() {
            if(this.showInactivityStateWarning) {
                return;
            }
            this.inactivityDurationSec = (this.appInactivityTimestamp ? (TELSA.moment().unix() - this.appInactivityTimestamp) : 0);
            // Check if the app has been not visible long enough to go into "inactivity mode" or check if we need to warn user about impending inactivity mode.
            if(this.inactivityDurationSec && this.inactivityTimeoutSec && this.inactivityTimeoutWarningSec) {
                if(this.inactivityDurationSec > this.inactivityTimeoutSec) { // We hit the timeout so go into inactivity mode
                    this.startInactivityMode();
                }
                else if(this.inactivityDurationSec > this.inactivityTimeoutWarningSec) { // we just hit the warning threshold
                    this.appInactivityStateWarningInterval = setInterval(this.appInactivityStateWarningIntervalHandler, 1000);
                }
            }
        },

        startInactivityMode: function() {
            clearInterval(this.appInactivityStateWarningInterval);
            clearInterval(this.checkForInactivityInterval);
            this.$store.commit('setInactivityMode', true);
            if(this.$socket) {
                this.$socket.disconnect(); // Disconnect from websocket
            }
        },

        setupVisibilityChangeBlurFocusHandlers: function() {
            let self = this;

            let wakeUp = function() {
                if(self.$store.state.inactivityMode) { // If we were in inactivity mode then refresh app
                    location.reload();
                }
                clearInterval(self.appInactivityStateWarningInterval);
                self.showInactivityStateWarning = false;
                self.appInactivityTimestamp = null; // otherwise clear the timer
            }


            if(self.appInactivityMechanism == "visibilitychange") {
                console.log('SETTING appInactivityMechanism: visibilitychange');
                // Detect when user switches tabs or minimizes the browser
                document.addEventListener('visibilitychange', function() {
                    if (document.visibilityState === 'hidden') {
                        console.log('Tab is not active or the browser is minimized');
                        self.appInactivityTimestamp = TELSA.moment().unix();
                    } else if (document.visibilityState === 'visible') {
                        console.log('Tab is active again');
                        wakeUp();
                    }
                });
            }
            else if(self.appInactivityMechanism == "focusblur") {
                console.log('SETTING appInactivityMechanism: focusblur');
                // Detect when the user focuses away from the browser (e.g., switching to another app)
                window.addEventListener('blur', function() {
                    console.log('Browser is no longer focused (user switched to another app)');
                    self.appInactivityTimestamp = TELSA.moment().unix();
                });

                // Detect when the user returns to the browser
                window.addEventListener('focus', function() {
                    console.log('Browser is focused again');
                    wakeUp();
                });
            }
        }
    },

    mounted() {
        this.setupVisibilityChangeBlurFocusHandlers();
        this.checkForInactivityInterval = setInterval(this.checkForInactivity, (this.$props.checkIntervalSec * 1000));
    }

  
};
</script>

<style>

    #application-inactivity-mode-overlay {
        position: fixed;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        text-align: center;
        z-index: 100;
        opacity: 0.46;
        background-color: rgb(33, 33, 33);
        border-color: rgb(33, 33, 33);
    }
    #application-inactivity-mode {
        position: fixed;
        top: 50%;
        left: 50%;
        z-index: 101;
        transform: translate(-50%, -50%);
        background-color: #424242;
        padding: 1em;
        border-radius: 10px;
        border: #000000 solid 2px;
    }
    #application-inactivity-mode span {
        font-size: 38px;
        color: #ffffff;
        opacity: 1.75;
    }
    #application-inactivity-mode .timer-text.warn {
        color: yellow;
    }
    #application-inactivity-mode .timer-text.warn.danger {
        display: inline-block;
        color: red;
        animation: heartbeat 1.5s ease-in-out infinite both;
    }

    @keyframes heartbeat {
        from {
            transform: scale(1);
            transform-origin: center center;
            animation-timing-function: ease-out;
        }
        10% {
            transform: scale(0.91);
            animation-timing-function: ease-in;
        }
        33% {
            transform: scale(1.17);
            animation-timing-function: ease-in;
        }
        45% {
            transform: scale(1);
            animation-timing-function: ease-out;
        }
    }

</style>
